module.exports = __webpack_public_path__ + "img/ltkcurves-2x.784e36c.jpg";